module.exports = __webpack_public_path__ + "img/201911.5db637ba.png";